import { Box } from '@mui/material';
import CommonInput from '../../../component/form/common-input.component';

/** 时间段筛选选项值：午餐 / 晚餐 / 全天 */
export type TimePeriodValue = 'lunch' | 'dinner' | 'all_day';

/** 时间段筛选下拉的选项（i18n key 作为 label） */
const TIME_PERIOD_ITEMS = [
    { value: 'lunch' as const, label: 'dashboards_data_filter_lunch' },
    { value: 'dinner' as const, label: 'dashboards_data_filter_dinner' },
    { value: 'all_day' as const, label: 'dashboards_data_filter_all_day' },
];

/** 订单分析时段筛选条固定宽度（px），与看板三主卡区顶部布局一致 */
export const TIME_PERIOD_FILTER_WIDTH_PX = 300;

/**
 * 时间段筛选组件（午餐/晚餐/全天）
 * 使用公共表单 CommonInput，仅受控展示，不请求接口；固定宽度、左对齐由外层容器控制
 */
export default function TimePeriodFilter(props: Readonly<{
    /** 当前选中的时间段 */
    value: TimePeriodValue;
    /** 选择变更回调 */
    onChange: (value: TimePeriodValue) => void;
}>) {
    const { value, onChange } = props;
    return (
        <Box
            sx={{
                width: TIME_PERIOD_FILTER_WIDTH_PX,
                maxWidth: '100%',
                flexShrink: 0,
                boxSizing: 'border-box',
            }}
        >
            <CommonInput
                inputType="SELECT"
                value={value}
                onChange={(e) => onChange(e.target.value as TimePeriodValue)}
                items={TIME_PERIOD_ITEMS}
                size="small"
                sx={{ width: '100%', backgroundColor: 'var(--icon-neutral-100)' }}
            />
        </Box>
    );
}
